import { render, staticRenderFns } from "./EventsGrid.vue?vue&type=template&id=7b37ddaa&scoped=true"
import script from "./EventsGrid.vue?vue&type=script&lang=js"
export * from "./EventsGrid.vue?vue&type=script&lang=js"
import style0 from "./EventsGrid.vue?vue&type=style&index=0&id=7b37ddaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b37ddaa",
  null
  
)

export default component.exports